import { useEffect } from 'react';

export const useScrollToTopWhenLoaded = (isOrderNewCard = false) => {
    useEffect(() => {
        if (isOrderNewCard) {
            return;
        }
        const els = document.getElementsByClassName('go-to-landing');
        els?.[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, []);
};
